const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/znglists/$znglistEdit.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { setPageFullScreen } from '@/Components/templates/Page';
import { requireUserPostCaps } from '@/Router';
import { ZnglistQuery, type Znglist_Query, type Znglist_Query$data } from '@/graphql/queries/Znglist.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { useAppStore } from '@/inertia/AppStore';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
type Props = {
  isFallback?: boolean;
  data?: Znglist_Query$data;
};
export const Route = createFileRoute('/dash/znglists/$znglistEdit')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  loader: ({
    params
  }) => {
    return loadQuery<Znglist_Query>(RelayEnvironment, ZnglistQuery, {
      id: params.znglistEdit
    }, {
      fetchPolicy: 'store-or-network'
    });
  },
  beforeLoad({
    params
  }) {
    requireUserPostCaps('znglist', 'edit_post', {
      to: '/dash/znglists'
    });
    const id = params?.znglistEdit;
    if (!/[a-zA-Z1-9]+/g.test(id)) {
      redirect({
        to: '/dash/znglists'
      });
    }
  },
  onEnter: () => {
    setPageFullScreen('on');
    useAppStore.setState({
      ...useAppStore.getInitialState(),
      isAppPreview: true,
      pageType: 'znglist'
    });
  },
  onLeave: () => {
    setPageFullScreen('off');
    useAppStore.setState({
      ...useAppStore.getInitialState(),
      isAppPreview: false,
      pageType: null
    });
  }
});